import { InjectionToken } from '@angular/core';
import { IFileDownloader } from './file-downloader.interface';

export const FILE_DOWNLOADER = new InjectionToken<IFileDownloader>('FILE_DOWNLOADER');
